import React, { useEffect, useState } from 'react';
import { useProfile } from '../../contexts/ProfileContext';
import { fetchPreviousSeasonRank } from '../../utils/pointsApi';
import { getCurrentSeasonId } from '../../constants/pointValues';
import './SeasonRecapBanner.css';

/**
 * Shown at the top of the HomePage when the user's player_points.season_id
 * is stale (doesn't match current season), indicating a season just ended.
 *
 * Dismissable — stores dismissal in localStorage keyed by season_id.
 */
const SeasonRecapBanner = () => {
  const { user, previousSeason, setPreviousSeason } = useProfile();
  const [rank, setRank] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  const currentSeasonId = getCurrentSeasonId();

  useEffect(() => {
    if (!user || !previousSeason) return;

    // Check localStorage for dismissal
    const storageKey = `season_recap_dismissed_${previousSeason.season_id}`;
    try {
      if (localStorage.getItem(storageKey) === 'true') {
        setDismissed(true);
        return;
      }
    } catch {
      // ignore
    }

    // Fetch the user's rank from the previous season
    fetchPreviousSeasonRank(previousSeason.season_id, previousSeason.season_points)
      .then((r) => {
        if (r) setRank(r);
      });
  }, [user, previousSeason]);

  const handleDismiss = () => {
    setDismissed(true);
    if (previousSeason) {
      try {
        localStorage.setItem(
          `season_recap_dismissed_${previousSeason.season_id}`,
          'true',
        );
      } catch {
        // ignore
      }
    }
    // Clear from context so it doesn't re-render
    setPreviousSeason?.(null);
  };

  if (!user || !previousSeason || dismissed) return null;
  if (previousSeason.season_points === 0) return null;

  const seasonNum = previousSeason.season_id + 1;

  return (
    <div className="season-recap-banner">
      <div className="season-recap-content">
        <span className="season-recap-icon" role="img" aria-hidden="true">🏆</span>
        <div className="season-recap-text">
          <strong>Season {seasonNum} ended!</strong>
          <span>
            You finished{rank ? ` #${rank}` : ''} with{' '}
            <strong>{previousSeason.season_points.toLocaleString()} pts</strong>
          </span>
        </div>
      </div>
      <button className="season-recap-dismiss" onClick={handleDismiss} aria-label="Dismiss">
        &times;
      </button>
    </div>
  );
};

export default SeasonRecapBanner;
